/**
 * Format datetime based on user preferences (no timezone conversion)
 * Uses browser local time directly
 */
export const formatDateTime = (dateTimeStr, options = {}) => {
  if (!dateTimeStr) return 'N/A';
  
  const {
    timeFormat = '24',
    dateFormat = 'DD/MM/YYYY',
    showDate = true,
    showTime = true,
    showSeconds = false
  } = options;
  
  try {
    const date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return 'Invalid date';
    
    const parts = [];
    
    if (showDate) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      
      switch (dateFormat) {
        case 'MM/DD/YYYY':
          parts.push(`${month}/${day}/${year}`);
          break;
        case 'YYYY-MM-DD':
          parts.push(`${year}-${month}-${day}`);
          break;
        case 'DD/MM/YYYY':
        default:
          parts.push(`${day}/${month}/${year}`);
          break;
      }
    }
    
    if (showTime) {
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      
      if (timeFormat === '12') {
        const period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const timeStr = showSeconds 
          ? `${hours}:${minutes}:${seconds} ${period}`
          : `${hours}:${minutes} ${period}`;
        parts.push(timeStr);
      } else {
        const hoursStr = hours.toString().padStart(2, '0');
        const timeStr = showSeconds
          ? `${hoursStr}:${minutes}:${seconds}`
          : `${hoursStr}:${minutes}`;
        parts.push(timeStr);
      }
    }
    
    return parts.join(' ');
  } catch {
    return 'Invalid date';
  }
};

export const formatDate = (dateTimeStr, options = {}) => {
  return formatDateTime(dateTimeStr, { ...options, showTime: false });
};

export const formatTime = (dateTimeStr, options = {}) => {
  return formatDateTime(dateTimeStr, { ...options, showDate: false });
};
